"use client"

import { OneTagScript } from "@/components/pixel-scripts/one-tag-scripts/one-tag-script"
import { usePixelInjectionPermissionSnai } from "@/hooks/use-pixel-injection-permission"

export function OnetagSignupAllPagesPixelScriptSnai() {
  const canInjectPixels = usePixelInjectionPermissionSnai()

  if (!canInjectPixels) return null

  return <OneTagScript segmentGroup="724" scriptId="DT9-all-pages" />
}
